import React from "react";
import CommentEdit from "./CommentEdit";
import ImageWithFallback from "../../Common/ImageWithFallback";
import Currency from "../../../packs_helper/scripts/Currency";
import DateFormat from "../../../packs_helper/scripts/DateFormat";
import Stars from "../../Common/Stars";

const statusTexts = {
	approved: "Onaylandı",
	pending: "Beklemede",
	rejected: "Reddedildi",
	answer_approved: "Cevaplandı",
	answer_pending: "Beklemede",
	answer_rejected: "Reddedildi",
};

const MyCommentBoxMobile = React.forwardRef((props, ref) => {
	const [boxHeight, SetBoxHeight] = React.useState(0);
	const [editModeActive, SetEditMode] = React.useState(false);
	const boxRef = React.useRef(null);

	// React.useEffect(() => {
	// 	if (boxRef.current) {
	// 		const boxHeight = boxRef.current.clientHeight;
	// 		SetBoxHeight(boxHeight);
	// 	}
	// }, []);

	React.useImperativeHandle(ref, () => ({
		UpdateMaxHeight: () => {
			const boxHeight = boxRef.current.clientHeight;
			SetBoxHeight(boxRef.current.scrollHeight);
		},
	}));

	const ToggleWrapper = () => {
		const boxHeight = boxRef.current.clientHeight;
		if (boxHeight === 0) {
			props.GetDetail(props.id);
			SetBoxHeight(boxRef.current.scrollHeight);
			props.BoxOpen(props.id);
		} else {
			SetBoxHeight(0);
		}
	};

	const ToggleEditMode = () => {
		SetEditMode(!editModeActive);
	};

	React.useEffect(() => {
		if (props.show) {
			ToggleWrapper();
		} else {
			SetBoxHeight(0);
		}
	}, [props.show]);

	return (
		<div className="user-panel-box">
			<header onClick={ToggleWrapper}>
				<StatusIcon status={props.status} />
				<strong>#{props.id}</strong>-<h2>{props.name}</h2>
				<button className={"btn" + (boxHeight === 0 ? "" : " rotate-ccw-180")}>
					<svg className="icon">
						<use xlinkHref="#gs-icon-user-panel-caret-down"></use>
					</svg>
				</button>
			</header>
			<div
				className="user-panel-box-wrapper"
				style={{ maxHeight: boxHeight }}
				ref={boxRef}
			>
				<div className="user-panel-box-body">
					<div className="comment-container">
						<div className="comment-content">
							<div className="comment-content-user">
								<h2>{props.content.comment_user_name}</h2>
								<strong>{DateFormat(props.content.created_at)}</strong>
								<div />
								<Stars
									value={props.content.rating}
									xlinkHref="#gs-icon-user-panel-star"
								/>
							</div>
							{editModeActive ? (
								<CommentEdit
									id={props.id}
									message={props.content.comment}
									rating={props.content.rating}
								/>
							) : (
								props.content.comment
							)}
						</div>
						<div className="comment-buttons">

							<a href={props.content.product_path} target="_blank" className="btn btn-dark">
								<svg className="icon">
									<use xlinkHref="#gs-icon-user-panel-tag"></use>
								</svg>
								İlana Git
							</a>

							<StatusIcon status={props.status}>
								{statusTexts[props.status]}
							</StatusIcon>

							<button
								className="btn btn-default"
								onClick={ToggleEditMode}
								disabled={props.status === "pending" || props.status === "rejected"}
							>
								<svg className="icon">
									<use xlinkHref="#gs-icon-user-panel-edit"></use>
								</svg>
								Düzenle
							</button>
						</div>
						{props.content.store_comment && (
							<React.Fragment>
								<div className="comment-answer-content">
									<div className="comment-answer-content-user">
										<h2>
											<a
												href={props.content.answer_user_code ? `/mesajlarim?active_tab=${props.content.answer_user_code}` : null}
												target="_blank"
											>
												{props.content.answer_user_name}
											</a>
										</h2>
									</div>
									{props.content.store_comment}
								</div>
							</React.Fragment>
						)}
					</div>
				</div>
			</div>
		</div>
	);
});

const StatusIcon = (props) => {
	if (props.status === "approved" || props.status === "answer_approved") {
		return (
			<div
				className={
					(!props.children ? "status-icon" : "status-icon-with-content") +
					" status-icon-jungle"
				}
			>
				<svg className="icon">
					<use xlinkHref="#gs-icon-user-panel-approved"></use>
				</svg>
				{props.children}
			</div>
		);
	} else if (
		props.status === "rejected" ||
		props.status === "answer_rejected"
	) {
		return (
			<div
				className={
					(!props.children ? "status-icon" : "status-icon-with-content") +
					" status-icon-red"
				}
			>
				<svg className="icon">
					<use xlinkHref="#gs-icon-user-panel-rejected"></use>
				</svg>
				{props.children}
			</div>
		);
	} else {
		return (
			<div
				className={
					(!props.children ? "status-icon" : "status-icon-with-content") +
					" status-icon-orange"
				}
			>
				<svg className="icon">
					<use xlinkHref="#gs-icon-user-panel-pending"></use>
				</svg>
				{props.children}
			</div>
		);
	}
};

export default MyCommentBoxMobile;
export { StatusIcon };
